class ProductCard extends HTMLElement {
  constructor() {
    super();
    this.productDetails = this.querySelector('[product-details]');
    this.availableSizes = this.querySelector('[available-sizes]');

    this.id = this.getAttribute('data-id');
    this.page = this.getAttribute('data-page');
    this.url = this.querySelector('a').getAttribute('href');

    if (this.id && this.page && this.url) {
      this.addEventListener('click', () => {
        this.setHistory(this.id, this.page, this.url);
      });
    }
  }

  connectedCallback() {
    this.addEventListener('mouseenter', this.onEnter.bind(this));
    this.addEventListener('focusin', this.onEnter.bind(this));
    this.addEventListener('mouseleave', this.onLeave.bind(this));
    this.addEventListener('focusout', this.onLeave.bind(this));
  }

  disconnectedCallback() {
    this.removeEventListener('mouseenter', this.onEnter);
    this.removeEventListener('focusin', this.onEnter);
    this.removeEventListener('mouseleave', this.onLeave);
    this.removeEventListener('focusout', this.onLeave);
  }

  onEnter() {
    this.productDetails.classList.add('md:opacity-100');
    this.availableSizes.classList.add('md:opacity-100');
  }

  onLeave() {
    this.productDetails.classList.remove('md:opacity-100');
    this.availableSizes.classList.remove('md:opacity-100');
  }

  setHistory(id, page, url) {
    let stateData = history.state || {};
    stateData.collection_item_id = id;
    if (page) {
      history.replaceState(stateData, '', this.getUrlForPage(page));
    } else {
      history.replaceState(stateData, '');
    }
    history.scrollRestoration = 'auto';
    window.location.href = url;
  }

  getUrlForPage(page) {
    const url = new URL(window.location.href);
    const params = new URLSearchParams(url.search);

    if (page == 1) {
      params.delete('page');
    } else {
      params.set('page', page);
    }

    url.search = params.toString();

    return url.toString();
  }
}

customElements.define('product-card', ProductCard);
